export default "__VITE_ASSET__EolC1tSZ__"